"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var STOP_VOD_PLAYBACK = function () {
    return "mutation StopVodPlayback($assetId: ID!, $deviceId: ID!) {\n    stopVodPlayback(assetId: $assetId, deviceId: $deviceId )\n}";
};
exports.default = STOP_VOD_PLAYBACK;
//# sourceMappingURL=stopVodPlaybackMetadata.js.map